export default "__VITE_ASSET__Bfx1IKvJ__"